var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrint = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 -256 1792 1792",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M384 0h896v256H384zm0 640h896v384h-160q-40 0-68 28t-28 68v160H384zm1152-64q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45m128 0V160q0-13-9.5-22.5T1632 128h-224V-32q0-40-28-68t-68-28H352q-40 0-68 28t-28 68v160H32q-13 0-22.5 9.5T0 160v416q0 79 56.5 135.5T192 768h64v544q0 40 28 68t68 28h672q40 0 88-20t76-48l152-152q28-28 48-76t20-88V768h64q79 0 135.5-56.5T1664 576",
  transform: "matrix(1 0 0 -1 53.153 1270.237)",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/print.c1e2a80dcb760eafc4506f77de4269de.svg";